type Evaluation = Array<{
  title: string;
  summary: string;
  score: number | null;
}>;

export function parseEvaluation(text: string): Evaluation {
  try {
    // Remove escape characters and parse the JSON
    const cleaned = text?.replace(/\\n/g, "").replace(/\\"/g, '"').trim();
    const parsed = cleaned && JSON.parse(cleaned);
    return parsed;
  } catch (error) {
    console.error("Failed to parse the text:", error);
    return [];
  }
}
